import React, { Component } from 'react';
import { connect } from 'react-redux';
import MobileDetect from 'mobile-detect';
import AddressBar from '../../components/AddressBar';
import { formatPhone } from '../../helpers/normalizePhone';
import { AddressWrapperDiv } from '../../pages';
import * as addressReducer from '../../reducers/addressReducer';
import './style.css'

class HelpPage extends Component {
  state = {
    faqOpened: false
  }

  handleDirection = () => {
    const { direction, /*directionPlaceId*/} = this.props;
    // https://www.google.com/maps?q=place_id:ChIJj5EKio_Oj4ARu6aMc085hEE
    // https://www.google.com/maps/?saddr=Current+Location&daddr=3253+Sagewood+Ln,+San+Jose,+CA+95132,+USA 
    // window.open("https://maps.google.com/maps?q=place_id:" + directionPlaceId);
    window.open("https://maps.google.com/maps?saddr=Current+Location&daddr=" + direction);
    // /* if there's google maps app schema, it will get call */
    // window.location = "comgooglemaps://?place_id=" + directionPlaceId + "&zoom=14&views=traffic";
    // /* if there's no google maps app then open location in browser */
    // if (this.props.isPhone && this.props.isIPhone) {
    //   window.open("https://maps.apple.com/maps?saddr=Current%20Location&daddr=" + encodeURIComponent(direction));
    // } else {
    //   window.open("https://www.google.com/maps/place/?q=place_id:" + directionPlaceId);
    // }
  }

  getContactPhone = () => {
    if (!this.props.contactPhone) return '';
    return formatPhone(this.props.contactPhone);
  }
  isContactPhoneAvailable = () => {
    if (this.props.contactPhone) {
      return true;
    }
    return false;
  }

  renderSendText = () => {
    const md = new MobileDetect(window.navigator.userAgent);
    if (!this.props.text_number || !md.phone()) return null;
    const telNum = this.props.text_number;
    return (<a href={`sms:${telNum}`} className="help-item"><p>Send Message</p></a>);
  }

  toggleFAQ = () => this.setState({faqOpened: !this.state.faqOpened});

  renderFAQ = () => {
    if (!this.state.faqOpened) return null;
    return (
      <div>
        <div className="help-item"><p><a href="https://support.treez.io/hc/en-us/articles/360003285691-TreezSupport-How-to-Sign-Up-for-a-New-Online-Account-For-Consumers" target="_blank">How to Sign up for a New Account</a></p></div>
        <div className="help-item"><p><a href="https://support.treez.io/hc/en-us/articles/360003276932-TreezSupport-How-to-Checkout-and-Complete-Your-Online-Order-For-Consumers" target="_blank">How to Complete First Time Checkout</a></p></div>
        <div className="help-item"><p><a href="https://support.treez.io/hc/en-us/articles/4411867275661-TreezSupport-How-Do-I-Change-My-Online-Account-Password-For-Consumers" target="_blank">How to Reset Your Password</a></p></div>
      </div>
    );
  }

  render() {
    const { isAddressBarOpened, isPickUpAvailable } = this.props;
    const contactPhone = this.getContactPhone();
    const isContactPhoneAvailable = this.isContactPhoneAvailable();
    return (
      <div>
        <div className="help-options">
          { isContactPhoneAvailable && 
            <div className="help-item"><p>Call {this.props.dispensaryName} <a style={{color:'#'+this.props.secondaryColor}} href={`tel:${contactPhone}`}>{contactPhone}</a></p></div> }
          { isPickUpAvailable && 
            <div onClick={this.handleDirection} className="help-item"><p>Get Directions</p></div> }
          {this.renderSendText()}
          <div onClick={this.toggleFAQ} className="help-item"><p>Frequently Asked Questions</p></div>
          {this.renderFAQ()}
        </div>
      </div>
    );
}
}

const mapStateToProps = (state) => {
  return {
    contactPhone: state.config.ECOMMERCE_CONTACT_PHONE,
    text_number: state.config.text_number,
    isPhone: state.config.isPhone,
    isIPhone: state.config.is_iPhone,
    isAddressBarOpened: addressReducer.isAddressBarOpened(state),
    isPickUpAvailable: addressReducer.isPickUpAvailable(state),
    directionPlaceId: addressReducer.getDirectionPlaceId(state),
    direction: addressReducer.getDirection(state),
    secondaryColor: state.config.secondaryColor,
    dispensaryName: state.config.DISPENSARY_FULL_NAME
};
};

// const mapDispatchToProps = (dispatch) => {
//   return { 
//   };
// };

export default connect(mapStateToProps, null)(HelpPage);





// WEBPACK FOOTER //
// ./src/components/HelpPage/HelpPage.jsx